import { useTranslation } from 'react-i18next';

import { EmptyDataMessage } from '@/ui';

import { IncidentListComponent } from '@/features/shared/IncidentListComponent';
import { IncidentListLoadingPlaceholder } from '@/features/shared/IncidentListLoadingPlaceholder';
import { toRow } from '@ngsos/portal-core/incidents';

import { IncidentArchiveSummaryBox } from './IncidentArchiveSummaryBox';
import type { IncidentListItem } from './incidentsApi';

export type IncidentArchivePageListProps = {
  incidents: IncidentListItem[];
  isLoading: boolean;
};

export function IncidentArchivePageList({ incidents, isLoading }: IncidentArchivePageListProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <>
        <IncidentArchiveSummaryBox incidents={null} />

        <IncidentListLoadingPlaceholder />
      </>
    );
  }

  if (incidents.length === 0) {
    return <EmptyDataMessage text={t('IncidentArchive_IncidentList_NoIncidentsFound')} />;
  }

  return (
    <>
      <IncidentArchiveSummaryBox incidents={incidents} />

      <IncidentListComponent incidents={incidents.map(toRow)} />
    </>
  );
}
